import {IconProp} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import styles from './RoundButton.module.scss';

export interface RoundButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label?: string;
  variant?: 'primary' | 'secondary' | 'tertiary';
  icon: IconProp;
  size?: 'small' | 'medium';
}

function RoundButton({
  label,
  variant = 'primary',
  icon,
  size = 'medium',
  ...buttonProps
}: RoundButtonProps): JSX.Element {
  enum IconSize {
    small = 'lg',
    medium = '2x',
  }

  return (
    <div className={styles.wrapper}>
      <button
        id={`roundButton-${label}`}
        className={`${styles.button} ${styles[variant]} ${styles[size]}`}
        type="button"
        {...buttonProps}
      >
        <span className={styles.iconWrapper}>
          <FontAwesomeIcon icon={icon} size={IconSize[size]} />
        </span>
      </button>
      {label && <label htmlFor={`roundButton-${label}`}>{label}</label>}
    </div>
  );
}

export default RoundButton;
